import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../utils/auth";
import { resetAdminData } from "../reducers/adminSlice";
import { useTranslation } from "react-i18next";
import {
  logoutIcon,
  moonIcon,
  profileIcon,
  settingsIcon,
  superadminIcon,
} from "../constants/icons";
import useOutsideAlerter from "../hooks/useOutsideAlerter";
import { commonModuleName } from "../constants/config";

function NavUserProfileDropDown() {
  const paths = useSelector((state) => state.user.paths);
  const loggedUser = useSelector((state) => state.user.user.logged_in_user);
  const loggedUserType = useSelector((state) => state.user.user.is_logged_in);
  // const headerData = useSelector((state) => state.admin.header);
  // const profileData = useSelector((state) => state.admin.profile);
  const wrapperRef = useRef(null);
  const { t } = useTranslation(commonModuleName);
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const [colorScheme, setColorScheme] = useState("light");
  const [dropDownToggle, setDropDownToggle] = useState(false);
  useOutsideAlerter(wrapperRef, setDropDownToggle);

  const onDropDownClick = (toggle, e) => {
    if (e.target.classList.contains("user-profile")) {
      return setDropDownToggle((dropToggle) => !dropToggle);
    }
    setDropDownToggle(toggle);
  };

  let dropDownClasses = "dropdown-menu mw-dropdown-default dropdown-menu-end";
  if (dropDownToggle) {
    dropDownClasses += " show";
  }

  let profileImage = loggedUser.name.charAt(0);
  if (loggedUser.image) {
    profileImage = <img src={loggedUser.image} width="150" alt="Profile" />;
  }

  return (
    <div
      ref={wrapperRef}
      className="dropdown dropdown-select"
      onClick={onDropDownClick.bind(null, true)}
    >
      <div
        data-testid="profileicon"
        className="circle-wrap circle-wrap-md bg-circle-twilight text-white user-profile"
        data-bs-toggle="dropdown"
        data-bs-offset="0,7"
        aria-expanded={dropDownToggle}
      >
        {profileImage}
      </div>
      <ul
        data-testid="profiledropdown"
        className={dropDownClasses}
        aria-labelledby="dropdownMenuButton1"
        data-bs-popper="none"
      >
        <li>
          <a className="dropdown-item" href={"/" + (loggedUserType == "user" ? "student-dashboard/learner-profile" : loggedUserType + "/profile")}>
            {profileIcon}
            {` ${t("profile")}`}
          </a>
        </li>
        <li>
          <a className="dropdown-item" href={paths.base_protocol + paths.tenant_domain + "/dashboard/"}>
            {settingsIcon}
            {` ${t("settings")}`}
          </a>
        </li>
        {/* <li>
          <hr className="dropdown-divider" />
        </li> */}
        <li>
          <a className="dropdown-item" href="/logout">
            {logoutIcon}
            {` ${t("logout")}`}
          </a>
        </li>
      </ul>
    </div>
  );
}

export default NavUserProfileDropDown;
